import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { ApplicationState } from 'AppReducer'
import { PartnerDeliveryConfigType } from './redux/types'
import { createPartnerDeliveryConfig, getPartnerDeliveryConfigs } from './redux/actions'

import DeliveryItem from './components/DeliveryItem'
import './styles/PartnerDelivery.scss'

const PartnerDeliveryConfig: React.FC<{ type: PartnerDeliveryConfigType, label: string }> = ({ type, label }) => {
  const dispatch = useDispatch()
  const { partner } = useSelector((state: ApplicationState) => state.partnerReducer)
  const { deliveryConfigs } = useSelector((state: ApplicationState) => state.partnerDeliveryConfigReducer)

  function handleCreate (): void {
    if (partner) {
      createPartnerDeliveryConfig(partner.id, { type, min: 0, max: 0, price: 0 })(dispatch)
    }
  }

  useEffect(() => {
    if (partner) {
      getPartnerDeliveryConfigs(partner.id)(dispatch)
    }
    // eslint-disable-next-line
  }, [dispatch, partner])

  if (!partner) {
    return null
  }

  return (
    <div className="panel row partner-delivery-config margin-top-32">
      <div className="ballon">{ label }</div>

      <div className="row margin-top-8 justify-start align-end">
        {
          deliveryConfigs
            .filter(item => item.type === type)
            .map((item, i) => <DeliveryItem key={i} partnerId={partner.id} item={item} />)
        }

        <span className="button secondary added-plus" onClick={handleCreate}>
          <i className="fa fa-plus"/> Adicionar
        </span>

      </div>
    </div>
  )
}

export default PartnerDeliveryConfig
